import React from "react";
import Image from "../atoms/Image";

const SlideLink = ({ link, children }) => {
    if (link) {
        return (
            <a href={link} className="slide__content">{children}</a>
        )
    } else {
        return (
            <div className="slide__content">{children}</div>
        )
    }
}

const Slide = ({ item, primary, large }) => {
    return (
        <div
            className={`slide ${primary ? "primary" : ""}`}
        >
            <SlideLink link={item.link}>
                <Image
                    src={item.image}
                />
                <div className={`slide__copy ${large ? "large" : ""}`}>
                    <div className="main">{item.main}</div>
                    <div className="secondary">{item.secondary}</div>
                </div>
            </SlideLink>
        </div>
    );
};

export default Slide;
